import { useEffect } from 'react';

import * as helpers from 'utils/helpers';

import { useWizardContext } from '../context';

/**
 * custom hook to provide user transition whenever the user changes step
 * @param options Optional custom options on where to transition the user to upon changes to given stepId
 */
export default function useTransition(options?: ScrollToOptions, onComplete?: () => void) {
  const { delayedLoadingMs, dispatch, currentStepId } = useWizardContext();

  useEffect(() => {
    // Only when the requested delay value is different from 0, then perform the transition effect
    if (delayedLoadingMs !== 0) {
      dispatch({
        type: 'STEP_TRANSITION',
        loading: true
      });
      const timer = setTimeout(() => {
        dispatch({
          type: 'STEP_TRANSITION',
          loading: false
        });

        if (onComplete) {
          onComplete();
        }
      }, delayedLoadingMs);
      helpers.scrollTo(options);

      // this will clear Timeout when component unmount
      return function cleanup() {
        clearTimeout(timer);
      };
    } else {
      if (onComplete) {
        onComplete();
      }
    }
  }, [delayedLoadingMs, dispatch, options, currentStepId, onComplete]);
}
